import { render, staticRenderFns } from "./EditOrganization.vue?vue&type=template&id=0c68a08c&scoped=true"
import script from "./EditOrganization.vue?vue&type=script&lang=js"
export * from "./EditOrganization.vue?vue&type=script&lang=js"
import style0 from "./EditOrganization.vue?vue&type=style&index=0&id=0c68a08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c68a08c",
  null
  
)

export default component.exports